import React, { useEffect, useState } from 'react'
import Fut from './tabla_posiciones/Fut/Fut'
import Basquetbol from './tabla_posiciones/Basquetbol/Basquetbol'
import Voleibol from './tabla_posiciones/Voleibol/Voleibol'
import Rugby from './tabla_posiciones/Rugby/Rugby'
import AcumuladaStandings from './acumulada/AcumuladaStandings.jsx'

import { formatIdSport } from '../../utils/formatIdSport.js'
import { getConfigCategory } from '../../services/configCategoryService.js'
import { showAccumulatedTab } from '../../utils/accumulatedStandingsDisplay.js'
import { useParams } from "react-router-dom";

const PosicionesArea = () => {
    const { idevent, idsport } = useParams();
    // FTR-0065: el sub-tab "Acumulada" solo existe con "Tabla acumulada (nueva)" encendida y un deporte soportado.
    const [config, setConfig] = useState(null);
    const [tab, setTab] = useState('grupos');

    useEffect(() => {
        let alive = true;
        const load = () => {
            getConfigCategory({ idevent, idsport })
                .then((data) => { if (alive) setConfig(data || null); })
                .catch(() => { if (alive) setConfig(null); });
        };
        if (idevent && idsport) load();
        const onConfigUpdated = (event) => {
            const detail = event?.detail || {};
            if (Number(detail.idevent) === Number(idevent) && Number(detail.idsport) === Number(idsport)) load();
        };
        window.addEventListener('winscore:config-category-updated', onConfigUpdated);
        return () => {
            alive = false;
            window.removeEventListener('winscore:config-category-updated', onConfigUpdated);
        };
    }, [idevent, idsport]);

    const formattedSport = formatIdSport(parseInt(idsport))

    const renderPositions = () => {
        switch (formattedSport) {
            case 1:
            case 2:
            case 5:
                return <Fut />;
            case 3:
            case 7:
                return <Voleibol />;
            case 4:
                return <Basquetbol />;
            case 6:
                return <Rugby />
            default:
                return <p>No hay datos de posiciones disponibles.</p>;
        }
    };

    if (!showAccumulatedTab(config, idsport)) {
        return (
            <div>
                {renderPositions()}
            </div>
        )
    }

    const tabClass = (key) =>
        `rounded-md px-4 py-2 text-sm font-semibold transition ${tab === key ? 'bg-blue-600 text-white shadow' : 'bg-white text-gray-700 ring-1 ring-gray-200 hover:bg-gray-50'}`;

    return (
        <div>
            <div role="tablist" aria-label="Posiciones" className="mb-4 flex gap-2 px-4">
                <button type="button" role="tab" aria-selected={tab === 'grupos'} className={tabClass('grupos')} onClick={() => setTab('grupos')}>
                    Grupos
                </button>
                <button type="button" role="tab" aria-selected={tab === 'acumulada'} className={tabClass('acumulada')} onClick={() => setTab('acumulada')}>
                    Acumulada
                </button>
            </div>
            {tab === 'acumulada' ? <AcumuladaStandings idevent={idevent} idsport={idsport} /> : renderPositions()}
        </div>
    )
}

export default PosicionesArea